const map = {
	"./adminSubscriptionsPage.js": 6941,
	"./advancedAnalytics.js": 9663,
	"./candidatesPage.js": 3632,
	"./collaborationManagementPage.js": 2652,
	"./collaborationStatus.js": 8554,
	"./collationComponents.js": 5006,
	"./common.js": 6352,
	"./comparativeAnalysis.js": 3146,
	"./comprehensiveAnalytics.js": 8077,
	"./cookiePolicy.js": 2253,
	"./councilDetail.js": 9479,
	"./councilManagement.js": 8141,
	"./councilResultsInput.js": 3068,
	"./dashboard.js": 6797,
	"./electionMap.js": 3138,
	"./electionNight.js": 8434,
	"./elections.js": 645,
	"./exportPanel.js": 9497,
	"./footer.js": 5894,
	"./historicalComparison.js": 5356,
	"./interactiveMap.js": 5251,
	"./liveComponents.js": 8187,
	"./liveReporting.js": 921,
	"./login.js": 964,
	"./mapView.js": 2918,
	"./mobileNav.js": 6634,
	"./notifications.js": 9209,
	"./parliamentaryManagement.js": 1501,
	"./partyTrends.js": 2113,
	"./pollingStationsPage.js": 4848,
	"./presidentialManagement.js": 9468,
	"./privacyPolicy.js": 891,
	"./projectedWinners.js": 9433,
	"./refundPolicy.js": 6869,
	"./regionalManagement.js": 8535,
	"./register.js": 4360,
	"./resultsCollation.js": 440,
	"./resultsInput.js": 691,
	"./resultsView.js": 5994,
	"./scheduledReports.js": 2339,
	"./senatorialManagement.js": 8534,
	"./settings.js": 4788,
	"./shareButtons.js": 8245,
	"./shellComponents.js": 1775,
	"./statistics.js": 1894,
	"./subscriptionPage.js": 1419,
	"./subscriptionPlanManagementPage.js": 8871,
	"./subscriptionSuccessPage.js": 7866,
	"./termsOfService.js": 172,
	"./unifiedDashboard.js": 67,
	"./userManagementPage.js": 7526,
	"./verificationPortal.js": 736
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2864;